<script>
export default {
  name: "nav",
  data() {
    return {
      permissionList: [],
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            id: 2,
            _name: "CSidebarNavItem",
            name: `HOME`,
            to: "/",
            icon: "cil-bar-chart"
          },
          {
            id: 7,
            _name: "CSidebarNavItem",
            name: `Prediction List`,
            to: "/prediction",
            icon: "cil-list"
          },
          {
            id: 1,
            _name: "CSidebarNavItem",
            name: `LOGS`,
            to: "/logs",
            icon: "cil-list"
          },
          {
            id: 3,
            _name: "CSidebarNavItem",
            name: `Branch Keyword`,
            to: "/Branch-Keyword",
            icon: "cil-list"
          },
          {
            id: 4,
            _name: "CSidebarNavItem",
            name: `Product Keyword`,
            to: "/Product-Keyword",
            icon: "cil-list"
          },
          {
            id: 8,
            _name: "CSidebarNavItem",
            name: `Format Keyword`,
            to: "/Format-Keyword",
            icon: "cil-list"
          },
          {
            id: 8,
            _name: "CSidebarNavItem",
            name: `Prompt Template`,
            to: "/Prompt-Template",
            icon: "cil-list"
          },
          {
            id: 5,
            _name: "CSidebarNavItem",
            name: `CheckPredict`,
            to: "/CheckPredict",
            icon: "cil-list"
          },
          {
            id: 6,
            _name: "CSidebarNavItem",
            name: `DetectOCR`,
            to: "/DetectOCR",
            icon: "cil-list"
          }
          // {
          //   id: 3,
          //   _name: "CSidebarNavItem",
          //   name: `MESSAGE LOG`,
          //   to: "/message-log",
          //   icon: "cil-list",
          // },
          // {
          //   id: 4,
          //   _name: "CSidebarNavItem",
          //   name: `IMAGE MAP`,
          //   to: "/image-map",
          //   icon: "cil-image",
          // },
          // {
          //   id: 4,
          //   _name: "CSidebarNavItem",
          //   name: `SENTIMENT TRAINING`,
          //   to: "/sentiment-training",
          //   icon: "cil-comment-bubble",
          // },
          // {
          //   id: 5,
          //   _name: "CSidebarNavItem",
          //   name: `SETTING TIME`,
          //   to: "/setting-time",
          //   icon: "cil-settings",
          // },
          // {
          //   id: 6,
          //   _name: "CSidebarNavItem",
          //   name: `EMAIL CONFIG`,
          //   to: "/email-config",
          //   icon: "cil-settings",
          // },
          // {
          //   id: 5,
          //   _name: "CSidebarNavItem",
          //   name: `SETTING WIDGET`,
          //   to: "/setting-widget",
          //   icon: "cil-settings",
          // },
          // {
          //   id: 7,
          //   _name: "CSidebarNavItem",
          //   name: `USER`,
          //   to: "/user",
          //   icon: "cil-user",
          // },
        ]
      }
    };
  },
  computed: {
    sidebarItems() {
      return [this.sidebar];
    }
  },
  created: async function () {},
  methods: {}
};
</script>
